@use "sass:math";

$browser-context: 16; // Default

@function em($pixels, $context: $browser-context) {
  @return #{math.div($pixels, $context)}em;
}

$error: #EF4443;

:host {
  display: block;
  width: 100%;
  font-size: inherit;
  font-family: inherit;
}

.form__label {
  display: block;
  font-weight: 500;
  font-size: em(14);
}

.form__group {
  margin-bottom: em(20);
}

.form__group.field-checkbox {
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: flex-start;
}

.form__group--error.field-checkbox .form__label {
  color: $error;
}

.form__group.field-checkbox [type="checkbox"] {
  margin-right: em(15);
}

select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  color: inherit;
}

textarea {
  max-width: 100%;
}

[type="checkbox"] {
  height: em(20);
  width: em(20);
}

.field-checkbox label {
  flex: 1;
}

[type="text"],
[type="email"],
textarea,
select {
  box-sizing: border-box;
  margin-top: em(10);
  width: 100%;
  display: block;
  border-radius: em(6);
  appearance: none;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: .5rem .75rem;
  font-size: em(14);
  font-family: inherit;
  line-height: 1.5rem;
}

.form__control--error {
  border-color: $error;
}

.form__control.form__control--error:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-color: $error;
  box-shadow: 0 0 0 1px $error;
}

// .form__control:focus {
//   outline: 2px solid transparent;
//   outline-offset: 2px;
//   border-color: var(--primary);
//   box-shadow: 0 0 0 1px var(--primary);
// }

.form__control[disabled] {
  opacity: .5;
}

.form__error {
  display: block;
  margin-top: em(5);
  font-size: em(14);
  color: $error;
}

.form__submit {
  width: 100%;
  background: var(--primary);
  border: none;
  color: #fff;
  border-radius: em(6);
  font-size: em(16);
  font-family: inherit;
  padding: .7rem .75rem;
  cursor: pointer;
}

// .form__submit:focus {
//   outline-color: var(--primary);
//   outline-offset: 2px;
// }

.form__submit:hover {
  box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);
}

.form__submit[disabled] {
  background: #ddd;
  color: inherit;
}

.header {
  margin-bottom: em(15);
}

.header__heading {
  margin-top: 0;
  margin-bottom: 0;
  font-size: em(20);
}

.success {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.success__icon {
  font-size: em(64);
  color: var(--primary);
}

.success__message {
  font-size: em(16);
  font-weight: 500;
  padding-left: em(15);
  padding-right: em(15);
  line-height: 150%;
}